import { HttpHeaders } from '@angular/common/http';

const headers = new HttpHeaders().set(
  'Content-Type',
  'application/x-www-form-urlencoded'
);
export const urlEncodedHeaders = { headers };
